<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<!-- {{"ADD" | translate }} {{"GRUPO" | translate }} -->
<form [formGroup]="itemForm" (ngSubmit)="submit()"></form>
<div mat-dialog-content>
  <mat-card class="p-0">
    <mat-tab-group>
      <mat-tab label="Preços">
        <form [formGroup]="itemForm" (ngSubmit)="submit()">
          <div fxLayout="row wrap" fxLayout.lt-sm="column">
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskUpper" matInput name="descricao" matInput type="text"
                  [formControl]="itemForm.controls['descricao']" placeholder="Descrição">
              </mat-form-field>
              <small
                *ngIf="itemForm.controls['descricao'].hasError('required') && itemForm.controls['descricao'].touched"
                class="form-error-msg"> Descrição é obrigatório </small>
            </div>

            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskUpper" matInput name="codigo" matInput type="text"
                  [formControl]="itemForm.controls['codigo']" placeholder="Código">
              </mat-form-field>
              <small *ngIf="itemForm.controls['codigo'].hasError('required') && itemForm.controls['codigo'].touched"
                class="form-error-msg"> Código é obrigatório </small>
            </div>

            <div fxFlex="50" class="pr-1">
              <mat-checkbox name="desativado" [formControl]="itemForm.controls['desativado']">Desativado?</mat-checkbox>
            </div>



            <div fxFlex="100" class="mt-1">
              <button mat-raised-button color="primary" [disabled]="itemForm.invalid">{{"SAVE" | translate }}</button>
              <span fxFlex></span>
              <button mat-button color="warn" type="button" (click)="close()">{{"CANCEL" | translate }}</button>
            </div>

          </div>
        </form>
      </mat-tab>

      
      <mat-tab label="Tabelas" *ngIf="itemForm.controls['uuid'].value !== null">
        <div fxLayout="row wrap" fxLayout.lt-sm="column">
          <div fxFlex="50" class="pr-1">
            <button mat-button color="primary" (click)="openPopUp({}, true, this.itemForm.controls['id'].value)">
              Adicionar Tabela </button>
          </div>
        </div>
        <mat-card class="p-0" [@animate]="{value:'*',params:{y:'50px',delay:'300ms'}}">
          <mat-card-content class="p-0">
            <ngx-datatable class="material ml-0 mr-0" [rows]="rows" [headerHeight]="50" [footerHeight]="50"
              [messages]="{emptyMessage:'Nenhuma tabela encontrada'}" [scrollbarH]="true" [limit]="pageSize"
               [rowHeight]="50"> <ngx-datatable-column name="#" [width]="25">
            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
              <strong>{{ rowIndex+1 }}</strong>
            </ng-template>
          </ngx-datatable-column>
              <ngx-datatable-column name="Opções" [flexGrow]="1" [width]="100">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <button mat-icon-button mat-sm-button color="primary" class="mr-1" (click)="openPopUp(row)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button [disabled]="true" mat-sm-button color="warn" (click)="deleteItem(row)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Código" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row?.codigo }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Descrição" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row?.descricao }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="índice" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row?.indice }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="tipo" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row?.tipo }}
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </mat-card-content>
        </mat-card>

      </mat-tab>
    </mat-tab-group>
  </mat-card>
</div>